import { isObject, serializeParams } from '../utils/util';
/**
 * 简单封装 xhr 返回 promise
 * @param {string} url 请求url
 * @param {object} config xhr 请求使用的配置
 * @returns {promise} 请求结果promise
 */
export default function request(url, config) {
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        var requestData = null;
        if (isObject(config.data)) {
            requestData = JSON.stringify(config.data);
        }
        request.open(config.method || 'GET', buildUrl(url, config.params));
        if (config.headers) {
            Object.entries(config.headers).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                request === null || request === void 0 ? void 0 : request.setRequestHeader(key, value);
            });
        }
        request.timeout = config.timeout || 0;
        request.onreadystatechange = function () {
            if (!request || request.readyState !== 4) {
                return;
            }
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 &&
                !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                return;
            }
            if (request.status < 400) {
                //   处理数据体
                var ct = request.getResponseHeader('content-type');
                var data = void 0;
                if (ct && ct.indexOf('json') > -1) {
                    try {
                        data = JSON.parse(request.response);
                    }
                    catch (parseError) {
                        reject("Parse Error: " + parseError.message);
                        return;
                    }
                }
                else {
                    data = request.response;
                }
                resolve({
                    status: request.status,
                    data: data,
                    headers: request
                        .getAllResponseHeaders()
                        .trim()
                        .split(/[\r\n]+/)
                        .reduce(function (prev, cur) {
                        var parts = cur.split(': ');
                        var header = parts.shift();
                        var value = parts.join(': ');
                        if (header) {
                            prev[header.toLowerCase()] = value;
                        }
                        return prev;
                    }, {}),
                });
            }
            else {
                reject("Request failed with status " + request.status);
            }
            // clean up  request
            request = null;
        };
        request.onabort = function () {
            if (!request) {
                return;
            }
            reject('Request aborted');
            request = null;
        };
        request.onerror = function () {
            reject('Network Error');
            request = null;
        };
        request.ontimeout = function () {
            reject('Timeout');
            request = null;
        };
        // if (requestData) {
        //   request.setRequestHeader &&
        //     request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
        // }
        request.send(requestData);
    });
}
function buildUrl(url, params) {
    if (!params) {
        return url;
    }
    var serializedParams = serializeParams(params);
    if (serializedParams) {
        url += '?' + serializedParams;
    }
    return url;
}
//# sourceMappingURL=web-request.js.map